module.exports = __webpack_public_path__ + "img/7.5c6b21dc.png";